import{red}from'@material-ui/core/colors';import{createTheme}from'@material-ui/core/styles';// A custom theme for this app
var theme=createTheme({palette:{primary:{// main: '#556cd6',
main:'#650874'// 清华紫
},secondary:{// main: '#19857b',
main:'#80268e'// 色盘生成 https://www.sessions.edu/color-calculator/
},error:{main:red.A400},background:{default:'#fff'}}});export default theme;